sw_mwjp_widget.games = {};
sw_mwjp_widget.games.currenctGames = [];

sw_mwjp_widget.games.buildGames = function (games) {
    games.forEach(game => {
        if (!game.draw) {
            let src = game.image;
            let game_code = game.game;
            document.getElementById("sw-widget-gamesContainer").appendChild(sw_mwjp_widget.main.createElement('div',
                [
                    ["class", "widget-innerGames__wrapper"]
                ], `<div><img src=${src} id=${game_code}></div>`));

            document.getElementById(game_code).onclick = (data) => {
                const gameLaunch = {
                    "provide": "skywindgroup",
                    "eventType": "game-launch",
                    "game_code": data.srcElement.id
                };
                window.parent.postMessage(
                    JSON.stringify(gameLaunch),
                    "*"
                );
            };
            game.draw = true;
        }
    });
};

/**
 example for request:
 {
    "provide": "skywindgroup",
    "eventType": "game-launch",
    "game_code": "sw_rm" // Game code
}

 how to listen for post messages (from parent frame):
 window.addEventListener("message", ((msg) => {
    const json_req = JSON.parse(msg.data);
}));

 example for listen (in the same frame):

 window.top.addEventListener("message", ((msg) => {
    const json_req = JSON.parse(msg.data);
}));

 */